module.exports = __webpack_public_path__ + "static/media/permissiontype.bc80a871.svg";